export class ConfigHelper {

    public static Version: string = '1.11.24';
    public static ApiVersion: string = 'v4';

    
    /**/  // --------------------------------------- API ----------------------------------------------- //
    //
    // -- URL API Servidor Prod -- //
    public static Env : string           = 'prod';
    public static UrlApi: string         = 'https://api.indicar.info/api/';
    public static OrcamentosPDF: string  = "https://api.indicar.info/api/v1/baixaOrcamentos/";
    public static urlSocket: string      = "wss://node-indicar.azurewebsites.net";
    //
    //                             // -- URL API Servidor Hml -- //
    // public static Env: string = 'hml';
    // public static UrlApi: string = 'https://hml.indicar.info/api/';
    // public static OrcamentosPDF: string = "https://hml.indicar.info/api/v1/baixaOrcamentos/";
    // public static urlSocket: string = "wss://node-indicar.azurewebsites.net";
    //
    //                             // -- URL API Local -- //
    // public static Env: string = 'local';
    // public static UrlApi: string = 'http://localhost:8000/api/';
    // public static OrcamentosPDF: string = "http://localhost:8000/api/v1/baixaOrcamentos/";
    // public static urlSocket: string = "wss://node-indicar.azurewebsites.net";
    // // 
    /**/  // -------------------------------- ------------------------------------------------------------ //


    public static AWS_ACCESS_KEY_ID = 'AKIA5CV3U7N74WQCV3SM';

    public static AWS_SECRET_ACCESS_KEY = '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';

    public static AWS_DEFAULT_REGION = 'sa-east-1';

    public static AWS_BUCKET = 'varejo-storage';

    public static AWS_POOL_ID: 'sa-east-1:7d82d8dd-9fbd-4948-a60f-195ba0a13edd';

    public static ApiCheckListV1: string = 'checklist/indicar/';

    public static ApiAnexosV1: string = 'checklist_anexos/indicar/';

    public static TokenChecklist: string = '088eceae0ebef44e9b39b83bf1df285f2fd27c9550fc9b319b8df8b3bd5ef25234780156$1$0IM3sqIV$4kfgzIMhpmIXOAgdwDB5W0';

    public static Token: string = '6b4a31b2dade3fa25a09942e35ddd592d04b2247';

    /// integracao busca de placa 
    public static UrlDms: string = 'https://dms.camptecnologia.com.br/placadenatran/';

    public static TokenDms: string = 'f08Ae54b97c066d0ecSD256f97c0608e54b9ea26d0e54a7RRea2e135';

    public static UrlNotificacoes: string = "https://dev.acampa.app/sms-api/";

    public static TokenNotivicacoes: string = "e68fbaaac1a99a0a6144a5a9152a2d1705b6a7b8";


    public static storageKeys = {
        codConcessionaria: 'indicar_02_22_.codConcessionaria',
        cnpj: 'indicar_02_22_.cnpj',
        cpf: 'indicar_02_22_.cpf',
        atualizaautomaticamente: 'indicar_02_22_.atualizaautomaticamente',
        precoosagregados: 'indicar_02_22_.precoosagregados',
        concessionaria: 'indicar_02_22_.concessionaria',
        cardapios: 'indicar_02_22_.cardapios',
        marcamodelo: 'indicar_02_22_.marcamodelo',
        checklistEntrada: 'indicar_02_22_.checklistEntrada',
        checklistAdicional: 'indicar_02_22_.checklistAdicional',
        checklistMecanico: 'indicar_02_22_.checklistMecanico',
        checklistSaida: 'indicar_02_22_.checklistSaida',
        checklistOrcamento: 'indicar_02_22_.checklistOrcamento',
        checklistOficina: 'indicar_02_22_.checklistOficina',
        checklistInspecao: 'indicar_02_22_.checklistInspecao',
        cameraAberta: 'indicar_02_22_.cameraAberta',
        vipEspecialista: 'indicar_02_22_.vipEspecialista'
    }

}


// WEBPACK FOOTER //
// ./src/app/helpers/configHelper.ts